import { useSelector } from "react-redux";
import axiosHttp from "./interceptor";
import { emitToasterMsg } from "./toasterUtility";

export const postUsersInfo = async (payLoad) => {
	try {
		const response = await axiosHttp.post(
			`/api/Accounts/ListUsers`,
			payLoad
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const createNewUser = async (userRegistrationObj) => {
	try {
		const response = await axiosHttp.post(
			`api/Accounts/Register`,
			userRegistrationObj
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const changePassword = async (passwordObj) => {
	try {
		const response = await axiosHttp.post(
			`api/Accounts/ChangePassword`,
			passwordObj
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const changeOfficeSign = async (signObj) => {
	try {
		const response = await axiosHttp.post(
			`api/Accounts/ChangeOfficeSign`,
			signObj
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const updateOrganization = async (organizationObj) => {
	try {
		const response = await axiosHttp.post(
			`api/Accounts/UpdateUserOrganizationDetails`,
			organizationObj
		);
		return response.data;
	} catch (error) {
		console.error(error.message);
	}
};

export const getRoleWiseUsers = async () => {
	try {
		const response = await axiosHttp.get(`api/Accounts/GetRoleWiseUsers`);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const getRolesInfo = async () => {
	try {
		const response = await axiosHttp.get(`api/Accounts/GetRoles`);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const updateUserRoles = async (rolesObj) => {
	try {
		const response = await axiosHttp.post(
			`api/Accounts/AssignRolesForUser`,
			rolesObj
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const addNewUser = async (addNewUserObj) => {
	try {
		const response = await axiosHttp.post(
			`/api/Accounts/AddUser`,
			addNewUserObj
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const addNewRole = async (addRoleNameObj) => {
	try {
		const response = await axiosHttp.post(
			`api/Accounts/AddRole?roleName=${addRoleNameObj}`
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const getWCNsDetails = async (requestPayload) => {
	try {
		const response = await axiosHttp.post(
			`/api/Wcn/WcnList`,
			requestPayload
		);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};

export const getUserWCNsDetails = async (requestPayload, email) => {
	try {
		const response = await axiosHttp.post(
			`/api/Wcn/UserWcnList?userEmail=${email}`,
			requestPayload
		);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};

export const addWcn = async (wcnDetails, isUpdate) => {
	try {
		let WCNAPI = `api/Wcn/AddWcn`;
		if (isUpdate) {
			WCNAPI = `api/Wcn/UpdateWcn`;
		}
		const response = await axiosHttp.post(WCNAPI, wcnDetails);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};
export const generateAccessToken = async (wcnMstId) => {
	try {
		const response = await axiosHttp.get(
			`/api/Wcn/GetAccessToken?wcnMstId=${wcnMstId}`,

		);
		return response?.data;
	} catch (error) {
		return error;
	}
};

export const updateWCNForUser = async (userWCNObj) => {
	try {
		const response = await axiosHttp.post(
			`/api/Wcn/AssignWcns`,
			userWCNObj
		);
		return response?.data;
	} catch (error) {
		return error;
	}
};

export const getUserDetails = async () => {
	try {
		var wcnNum = sessionStorage.getItem("wcn");
		var getUserUrl = `api/Accounts/GetUser`;
		if (wcnNum) {
			getUserUrl = `api/Accounts/GetUser?wcnNumber=${wcnNum}`;
		}
		const response = await axiosHttp.get(getUserUrl);
		// localStorage.setItem("user", JSON.stringify(response?.data));
		return response?.data;
	} catch (error) { }
};

export const getEventLogsData = async () => {
	try {
		const response = await axiosHttp.get(`/api/Dashboard/EventLogs`);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};

export const createBulkExport = async (payload) => {
	try {
		const response = await axiosHttp.post(`api/Dashboard/CreateBulkExport`, payload);
		return response;
	} catch (error) {
		console.error(error);
		throw error;
	}
};

export const WCNList = async (searchKey) => {
	console.log("triggeredddd")
	try {
		const response = await axiosHttp.post(`api/Wcn/SearchWcn`, { searchKey });
		return response.data;
	} catch (error) {
		console.error("error:",error);
	}
};

export const GetLatestBulkExports = async () => {
	try{
		const response = await axiosHttp.get(`api/Dashboard/GetLatestBulkExports`);
		return response;
	}catch(error){
		console.log(error);
		
	}
}

export const GetExportedZip = async (referenceId) => {
    try {
        const response = await axiosHttp.get(
            'api/Dashboard/GetExportedZip',
            {
                params: { referenceId },  
                responseType: 'blob'      
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const GetLatestUnsatisfactoryVesselsExport = async (requestPayload) => {
	try{
		const response = await axiosHttp.post(`api/Dashboard/GetLatestUnsatisfactoryCiiExports`, requestPayload);
		return response;
	}catch(error){
		console.log(error);
		
	}
}